/* =========================================================
   DEKOFAR PRODUCT SYSTEM V2
   CORE JAVASCRIPT

   Tüm V2 ürün ailelerinde kullanılır.

   İçerik:
   - Helpers
   - Product JSON
   - Variant engine
   - Price
   - SKU
   - Stock
   - Quantity
   - Add to cart state
   - Variant event

   ÖNEMLİ:
   Option sırası Shopify data-option-position
   değerine göre belirlenir.
========================================================= */


/* =========================================================
   MONEY
========================================================= */

function dekofarV2FormatMoney(cents) {

  const value =
    Number(cents);

  if (
    !Number.isFinite(value)
  ) {
    return '';
  }

  return (
    new Intl.NumberFormat(
      'tr-TR',
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    ).format(
      value / 100
    ) + ' TL'
  );

}




/* =========================================================
   PRODUCT PAGE CAMPAIGN PRICE
   Theme settings are the storefront display source.
========================================================= */

function dekofarV2GetCampaignPrice(productData, price) {

  const numericPrice = Number(price);

  if (
    !productData ||
    productData.cart_discount_enabled === false ||
    !Number.isFinite(numericPrice)
  ) {
    return { active: false, price: numericPrice, badge: '' };
  }

  const threshold = Number(productData.cart_discount_threshold || 0);
  const type = String(productData.cart_discount_type || 'fixed');
  const value = Number(productData.cart_discount_value || 0);

  if (
    !Number.isFinite(threshold) ||
    numericPrice < threshold ||
    !Number.isFinite(value) ||
    value <= 0
  ) {
    return { active: false, price: numericPrice, badge: '' };
  }

  if (type === 'percentage') {
    if (value >= 100) {
      return { active: false, price: numericPrice, badge: '' };
    }

    const discountedPrice = Math.max(0, Math.round(numericPrice * (100 - value) / 100));

    return {
      active: discountedPrice < numericPrice,
      price: discountedPrice,
      badge: `%${new Intl.NumberFormat('tr-TR').format(value)} İNDİRİM`
    };
  }

  const fixedAmount = Number(productData.cart_discount_amount || Math.round(value * 100));

  if (!Number.isFinite(fixedAmount) || fixedAmount <= 0 || numericPrice <= fixedAmount) {
    return { active: false, price: numericPrice, badge: '' };
  }

  return {
    active: true,
    price: numericPrice - fixedAmount,
    badge: `${new Intl.NumberFormat('tr-TR').format(value)} TL İNDİRİM`
  };
}


/* =========================================================
   COMPARE AT PRICE
========================================================= */

function dekofarV2GetCompareAtPrice(
  variant
) {

  if (!variant) {
    return null;
  }

  if (
    variant.compare_at_price !==
      undefined &&
    variant.compare_at_price !==
      null
  ) {

    return Number(
      variant.compare_at_price
    );
  }

  if (
    variant.compareAtPrice !==
      undefined &&
    variant.compareAtPrice !==
      null
  ) {

    return Number(
      variant.compareAtPrice
    );
  }

  return null;
}


/* =========================================================
   FEATURED MEDIA ID
========================================================= */

function dekofarV2GetFeaturedMediaId(
  variant
) {

  if (!variant) {
    return null;
  }

  if (
    variant.featured_media &&
    variant.featured_media.id
  ) {

    return variant.featured_media.id;
  }

  if (
    variant.featuredMedia &&
    variant.featuredMedia.id
  ) {

    return variant.featuredMedia.id;
  }

  if (
    variant.featured_media_id
  ) {

    return variant.featured_media_id;
  }

  return null;
}


/* =========================================================
   PRODUCT JSON
========================================================= */

function dekofarV2ReadProductData(
  productRoot
) {

  if (!productRoot) {
    return null;
  }

  const script =
    productRoot.querySelector(
      '[data-dekofar-v2-product-json]'
    );

  if (!script) {
    return null;
  }

  try {

    return JSON.parse(
      script.textContent
    );

  } catch (error) {

    console.error(
      'Dekofar V2 product JSON okunamadı:',
      error
    );

    return null;
  }

}


/* =========================================================
   FIND VARIANT
========================================================= */

function dekofarV2FindVariant(
  productData,
  selectedOptions
) {

  if (
    !productData ||
    !Array.isArray(
      productData.variants
    ) ||
    !Array.isArray(
      selectedOptions
    )
  ) {
    return null;
  }

  return (
    productData.variants.find(
      (variant) => {

        if (
          !variant ||
          !Array.isArray(
            variant.options
          )
        ) {
          return false;
        }

        return variant.options.every(
          (
            optionValue,
            index
          ) => {

            return (
              optionValue ===
              selectedOptions[index]
            );

          }
        );

      }
    ) || null
  );

}


/* =========================================================
   OPTION POSITION
========================================================= */

function dekofarV2GetOptionPosition(
  select
) {

  if (!select) {
    return null;
  }

  const position =
    parseInt(
      select.getAttribute(
        'data-option-position'
      ),
      10
    );

  if (
    !Number.isFinite(position) ||
    position < 1
  ) {
    return null;
  }

  return position;
}


/* =========================================================
   PRODUCT / VARIANT ENGINE
========================================================= */

class DekofarProductV2 {

  constructor(root) {

    this.root =
      root;

    this.productData =
      dekofarV2ReadProductData(
        root
      );


    /* =====================================================
       GERÇEK VARYANT SELECTLERİ

       Sadece V2 varyant alanındaki selectler alınır.

       Daha sonra Shopify option position değerine
       göre sıralanır.

       position 1 -> variant.options[0]
       position 2 -> variant.options[1]
       position 3 -> variant.options[2]
    ===================================================== */

    this.optionSelects = [
      ...root.querySelectorAll(
        '[data-dekofar-v2-variants] select[data-option-position]'
      )
    ]
      .filter(
        (select) => {

          return (
            dekofarV2GetOptionPosition(
              select
            ) !== null
          );

        }
      )
      .sort(
        (
          a,
          b
        ) => {

          return (
            dekofarV2GetOptionPosition(a) -
            dekofarV2GetOptionPosition(b)
          );

        }
      );


    this.variantInput =
      root.querySelector(
        '[data-dekofar-v2-variant-id]'
      );

this.priceContainer =
  root.querySelector(
    '[data-dekofar-v2-price]'
  );

this.priceElement =
  root.querySelector(
    '[data-dekofar-v2-current-price]'
  );

this.comparePriceElement =
  root.querySelector(
    '[data-dekofar-v2-compare-price]'
  );

this.priceCampaignBadgeElement =
  root.querySelector(
    '[data-dekofar-v2-price-campaign-badge]'
  );


this.skuElement =
  root.querySelector(
    '[data-dekofar-v2-sku]'
  );

    this.addToCartButton =
      root.querySelector(
        '[data-dekofar-v2-add-to-cart]'
      );

    this.stockElement =
      root.querySelector(
        '[data-dekofar-v2-product-stock]'
      );

    this.stockTextElement =
      root.querySelector(
        '[data-dekofar-v2-product-stock-text]'
      );

    this.quantityInput =
      root.querySelector(
        '[data-dekofar-v2-quantity]'
      );

    this.minusButton =
      root.querySelector(
        '[data-dekofar-v2-quantity-minus]'
      );

    this.plusButton =
      root.querySelector(
        '[data-dekofar-v2-quantity-plus]'
      );


    this.init();
  }


  /* =======================================================
     INIT
  ======================================================= */

  init() {

    this.initQuantity();

    this.initVariants();

    if (
      this.productData &&
      this.optionSelects.length
    ) {

      this.updateVariant();
    }

  }


  /* =======================================================
     QUANTITY
  ======================================================= */

  initQuantity() {

    if (
      !this.quantityInput
    ) {
      return;
    }


    /* MINUS */

    if (
      this.minusButton
    ) {

      this.minusButton.addEventListener(
        'click',
        () => {

          const currentValue =
            parseInt(
              this.quantityInput.value,
              10
            ) || 1;

          this.quantityInput.value =
            Math.max(
              1,
              currentValue - 1
            );

          this.quantityInput.dispatchEvent(
            new Event(
              'change',
              {
                bubbles: true
              }
            )
          );

        }
      );
    }


    /* PLUS */

    if (
      this.plusButton
    ) {

      this.plusButton.addEventListener(
        'click',
        () => {

          const currentValue =
            parseInt(
              this.quantityInput.value,
              10
            ) || 1;

          this.quantityInput.value =
            currentValue + 1;

          this.quantityInput.dispatchEvent(
            new Event(
              'change',
              {
                bubbles: true
              }
            )
          );

        }
      );
    }


    /* MANUEL INPUT */

    this.quantityInput.addEventListener(
      'change',
      () => {

        let value =
          parseInt(
            this.quantityInput.value,
            10
          );

        if (
          !Number.isFinite(value) ||
          value < 1
        ) {

          value = 1;
        }

        this.quantityInput.value =
          value;

      }
    );

  }


  /* =======================================================
     VARIANT EVENTS
  ======================================================= */

  initVariants() {

    if (
      !this.productData ||
      !this.optionSelects.length
    ) {
      return;
    }

    this.optionSelects.forEach(
      (select) => {

        select.addEventListener(
          'change',
          () => {

            this.updateVariant();

          }
        );

      }
    );

  }


  /* =======================================================
     SELECTED OPTIONS

     Shopify position kullanılır.

     Örnek:

     Renk:
     data-option-position="1"

     Kg:
     data-option-position="2"

     Sonuç:

     [
       "Kırmızı",
       "1 Kg"
     ]
  ======================================================= */

  getSelectedOptions() {

    const selectedOptions = [];

    this.optionSelects.forEach(
      (select) => {

        const position =
          dekofarV2GetOptionPosition(
            select
          );

        if (
          position === null
        ) {
          return;
        }

        selectedOptions[
          position - 1
        ] =
          select.value;

      }
    );

    return selectedOptions;

  }


  /* =======================================================
     CURRENT VARIANT
  ======================================================= */

  updateVariant() {

    if (
      !this.productData
    ) {
      return;
    }

    const selectedOptions =
      this.getSelectedOptions();

    const variant =
      dekofarV2FindVariant(
        this.productData,
        selectedOptions
      );

    if (
      !variant
    ) {

      this.setUnavailableState();

      this.updateOptionAvailability();

      return;
    }

    this.setVariant(
      variant
    );

  }


  /* =======================================================
     SET VARIANT
  ======================================================= */

  setVariant(
    variant
  ) {

    if (
      !variant
    ) {
      return;
    }


    /* -------------------------------------------------------
       VARIANT ID
    ------------------------------------------------------- */

    if (
      this.variantInput
    ) {

      this.variantInput.value =
        variant.id;

      this.variantInput.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );
    }


/* -------------------------------------------------------
   PRICE + CAMPAIGN PREVIEW
------------------------------------------------------- */

const currentPrice =
  Number(variant.price);

const campaignPrice =
  dekofarV2GetCampaignPrice(
    this.productData,
    currentPrice
  );

if (this.priceContainer) {
  this.priceContainer.classList.toggle(
    'is-campaign-active',
    campaignPrice.active
  );
}

if (this.priceElement) {
  this.priceElement.textContent =
    dekofarV2FormatMoney(
      campaignPrice.active
        ? campaignPrice.price
        : currentPrice
    );
}

if (this.priceCampaignBadgeElement) {
  this.priceCampaignBadgeElement.hidden =
    !campaignPrice.active;

  this.priceCampaignBadgeElement.textContent =
    campaignPrice.active
      ? campaignPrice.badge
      : '';
}


/* -------------------------------------------------------
   COMPARE AT PRICE
   Kampanya aktifse ürünün gerçek Shopify fiyatı çizilir.
------------------------------------------------------- */

if (this.comparePriceElement) {

  const compareAtPrice =
    dekofarV2GetCompareAtPrice(variant);

  const hasComparePrice =
    Number.isFinite(compareAtPrice) &&
    Number.isFinite(currentPrice) &&
    compareAtPrice > currentPrice;

  this.comparePriceElement.hidden =
    !(campaignPrice.active || hasComparePrice);

  this.comparePriceElement.textContent =
    campaignPrice.active
      ? dekofarV2FormatMoney(currentPrice)
      : (hasComparePrice
          ? dekofarV2FormatMoney(compareAtPrice)
          : '');
}

    /* -------------------------------------------------------
       SKU
    ------------------------------------------------------- */

    if (
      this.skuElement
    ) {

      this.skuElement.textContent =
        variant.sku || '-';
    }


    /* -------------------------------------------------------
       ADD TO CART
    ------------------------------------------------------- */

    if (
      this.addToCartButton
    ) {

      this.addToCartButton.hidden =
        false;

      this.addToCartButton.disabled =
        !variant.available;

      this.addToCartButton.textContent =
        variant.available
          ? 'Sepete Ekle'
          : 'Stok Yok';
    }

    this.updateStockState(
      Boolean(
        variant.available
      )
    );


    /* -------------------------------------------------------
       URL
    ------------------------------------------------------- */

    this.updateUrl(
      variant.id
    );


    /* -------------------------------------------------------
       STOCK
    ------------------------------------------------------- */

    this.updateOptionAvailability();


    /* -------------------------------------------------------
       GLOBAL VARIANT EVENT
    ------------------------------------------------------- */

    this.root.dispatchEvent(
      new CustomEvent(
        'dekofar:v2:variant-change',
        {

          bubbles: true,

          detail: {
            variant: variant
          }

        }
      )
    );

  }


  /* =======================================================
     UNAVAILABLE VARIANT
  ======================================================= */

  setUnavailableState() {

    if (
      this.addToCartButton
    ) {

      this.addToCartButton.hidden =
        false;

      this.addToCartButton.disabled =
        true;

      this.addToCartButton.textContent =
        'Bu kombinasyon mevcut değil';
    }

    this.updateStockState(
      false
    );

  }


  /* =======================================================
     PRODUCT STOCK INDICATOR
  ======================================================= */

  updateStockState(
    isAvailable
  ) {

    if (
      !this.stockElement
    ) {
      return;
    }

    const available =
      Boolean(
        isAvailable
      );

    this.stockElement.classList.toggle(
      'is-in-stock',
      available
    );

    this.stockElement.classList.toggle(
      'is-out-of-stock',
      !available
    );

    this.stockElement.setAttribute(
      'data-available',
      available
        ? 'true'
        : 'false'
    );

    if (
      this.stockTextElement
    ) {

      this.stockTextElement.textContent =
        available
          ? 'Stokta'
          : 'Stok Yok';
    }

  }


  /* =======================================================
     URL VARIANT
  ======================================================= */

  updateUrl(
    variantId
  ) {

    if (
      !variantId
    ) {
      return;
    }

    try {

      const url =
        new URL(
          window.location.href
        );

      url.searchParams.set(
        'variant',
        variantId
      );

      window.history.replaceState(
        {},
        '',
        url.toString()
      );

    } catch (error) {

      /*
       * URL değişmese de ürün sistemi
       * çalışmaya devam eder.
       */

    }

  }


  /* =======================================================
     OPTION AVAILABILITY
  ======================================================= */

  updateOptionAvailability() {

    if (
      !this.productData ||
      !this.optionSelects.length
    ) {
      return;
    }

    const currentValues =
      this.getSelectedOptions();


    this.optionSelects.forEach(
      (select) => {

        const position =
          dekofarV2GetOptionPosition(
            select
          );

        if (
          position === null
        ) {
          return;
        }

        const selectIndex =
          position - 1;

        const wrapper =
          select.closest(
            '[data-dekofar-v2-option]'
          );

        if (
          !wrapper
        ) {
          return;
        }


        /* ===================================================
           COLOR STOCK
        =================================================== */

        const colorButtons = [
          ...wrapper.querySelectorAll(
            '[data-dekofar-v2-color-value]'
          )
        ];

        colorButtons.forEach(
          (button) => {

            const colorValue =
              button.getAttribute(
                'data-dekofar-v2-color-value'
              );

            if (
              !colorValue
            ) {
              return;
            }

            /*
             * Seçilen rengin en az bir
             * stoklu varyantı varsa aktif kalır.
             */

            const hasAvailableVariant =
              this.productData
                .variants
                .some(
                  (variant) => {

                    return (
                      Boolean(
                        variant.available
                      ) &&
                      Array.isArray(
                        variant.options
                      ) &&
                      variant.options[
                        selectIndex
                      ] ===
                        colorValue
                    );

                  }
                );

            this.setOptionButtonAvailability(
              button,
              hasAvailableVariant
            );

          }
        );


        /* ===================================================
           PACKAGE STOCK
        =================================================== */

        const packageButtons = [
          ...wrapper.querySelectorAll(
            '[data-dekofar-v2-package-value]'
          )
        ];

        packageButtons.forEach(
          (button) => {

            const packageValue =
              button.getAttribute(
                'data-dekofar-v2-package-value'
              );

            if (
              !packageValue
            ) {
              return;
            }

            /*
             * Mevcut renk ve diğer seçenekler korunur.
             * Sadece paket değeri değiştirilerek
             * kombinasyon aranır.
             */

            const candidateOptions =
              currentValues.slice();

            candidateOptions[
              selectIndex
            ] =
              packageValue;

            const candidateVariant =
              dekofarV2FindVariant(
                this.productData,
                candidateOptions
              );

            this.setOptionButtonAvailability(
              button,
              Boolean(
                candidateVariant &&
                candidateVariant.available
              )
            );

          }
        );

      }
    );

  }


  /* =======================================================
     OPTION BUTTON STATE
  ======================================================= */

  setOptionButtonAvailability(
    button,
    isAvailable
  ) {

    if (
      !button
    ) {
      return;
    }

    button.disabled =
      !isAvailable;

    button.classList.toggle(
      'is-unavailable',
      !isAvailable
    );

    button.setAttribute(
      'aria-disabled',
      isAvailable
        ? 'false'
        : 'true'
    );

    const soldOutText =
      button.querySelector(
        '[data-dekofar-v2-sold-out]'
      );

    if (
      soldOutText
    ) {

      soldOutText.hidden =
        isAvailable;

      soldOutText.textContent =
        isAvailable ? '' : 'Stok Yok';
    }

  }

}
/* =========================================================
   CORE INITIALIZER

   Bu fonksiyon yalnızca V2 ürünlerini initialize eder.

   DOMContentLoaded ve Shopify Theme Editor başlangıçlarını
   dekofar-v2-init.js yönetir.
========================================================= */

function initDekofarV2Products(scope) {

  const root =
    scope || document;

  const products = [];


  /* =======================================================
     SCOPE DOĞRUDAN PRODUCT ROOT İSE
  ======================================================= */

  if (
    root.matches &&
    root.matches(
      '.dekofar-v2-product'
    )
  ) {

    products.push(
      root
    );

  }


  /* =======================================================
     SCOPE İÇİNDE PRODUCT ROOT VARSA
  ======================================================= */

  if (
    root.querySelectorAll
  ) {

    root
      .querySelectorAll(
        '.dekofar-v2-product'
      )
      .forEach(
        (productRoot) => {

          products.push(
            productRoot
          );

        }
      );

  }


  /* =======================================================
     PRODUCTS
  ======================================================= */

  products.forEach(
    (productRoot) => {


      /*
       * Aynı ürün ikinci kez initialize edilmez.
       */

      if (
        productRoot.dataset
          .dekofarV2Initialized ===
        'true'
      ) {

        return;

      }


      productRoot.dataset
        .dekofarV2Initialized =
        'true';


      new DekofarProductV2(
        productRoot
      );

    }
  );

}


/* =========================================================
   GLOBAL ACCESS

   dekofar-v2-init.js bu fonksiyonu window üzerinden çağırır.
========================================================= */

window.initDekofarV2Products =
  initDekofarV2Products;
